import loadjs from 'loadjs';

export const isTestEnv = () => {
  if (isEvo) {
    return false;
  }
  if (import.meta.env.DEV) return true;
  return location.host.includes('test.');
};

const isEvo = import.meta.env.EVO;

// 是否为 win 客户端
export const isWin =  isEvo && vn?.external?.osType() === 'win';

export const isMac = isEvo && vn?.external?.osType() === 'mac';

/**
 * 挂载 web 问题反馈方法
 */
export const addWebIssueFeedback = async () => {
  try {
    if (!window?.VShortcut) { // 兜底 引入 loader
      await loadjs('//vfiles.gtimg.cn/tvideo2/p/component/v-shortcut/v-shortcut-loader.umd.js', { returnPromise: true });
    }
    window?.VShortcut?.aiseeSubmit({
      feedbackSource: 'loginHover',
    });
  } catch (error) {
    console.error('[nav-login-panel] 加载shortcut失败', error);
  }
};
